module.exports = __webpack_public_path__ + "img/首页2-3-hover.fdd6a61d.svg";